import React from 'react';
import globalHook from 'use-global-hook';
import encryptedLocalStorage from 'utils/encryptedLocalStorage';

const initialState = {
  count: 0,
  error: false,
  OTP: '',
  OTP1: '',
  isNewPin: true,
  isInvalidPin: false,
  open: false,
  open1: false,
  isDisabled: false,
  expanded: false,
  timer: 0,
  isInvalidOTP: false,
  isLoading: false,
  isBtnClick: false,
  isInvalidEmail: false,
  isInvalidNama: false,
  isInvalidTempat: false,
  isInvalidTangall: false,
  isInvalidTingall: false,
  isInvalidProvinci: false,
  isInvalidKabupaten: false,
  isInvalidKecamatan: false,
  isInvalidKelurahan: false,
  isInvalidUtama: false,
  isInvalidHp: false,
  isInvalidDiteSej: false,
  isInvalidDomisili: false,
  isInvalidSipil: false,
  isInvalidTangg: false,
  isInvalidJenis: false,
  isAllPersonalFilled: false,
  isInvalidNamaOrang: false,
  isInvalidNomorHpOrang: false,
  isInvalidNamaKeluarga: false,
  isInvalidNomorHpKeluarga: false,
  isAllFamilyFilled: false,
  isInvalidHubungan: false,
  isInvalidTipePeker: false,
  isInvalidBidangPeker: false,
  isInvalidPekerjan: false,
  isInvalidPendidkan: false,
  isInvalidNamaPerush: false,
  isInvalidMulai: false,
  isAllJobFilled: false,
  isInvalidTotalPeng: false,
  isInvalidTotalRumah: false,
  isInvalidTotalCicilan: false,
  isInvalidTotalHutang: false,
  isInvalidTujuanPin: false,
  isInvalidNamaBank: false,
  isInvalidRekening: false,
  isInvalidJelaskan: false,
  sayaTelahCheck: false,
  sayaTelah: false,
  sayaSetuju: false,
  nama_orang: '',
  nomor_hp_orang: '',
  nomor_hp_keluarga: '',
  nama_keluarga: '',
  hubungan: '',
  total_peng: '',
  total_rumah: '',
  total_cicilan: '',
  total_hutang: '',
  nama_bank: '',
  nomor_rekening: '',
  tujuan_pin: '',
  jelaskan: '',
  tipe_peker: '',
  bidang_peker: '',
  pekerjan: '',
  pendidkan: '',
  nama_per: '',
  mulai: '',
  apn_email: '',
  apn_nama_lengkap: '',
  apn_tempat: '',
  apn_tanggal_lahir: '',
  apn_tingall: '',
  apn_provinsi: '',
  apn_kabupaten: '',
  apn_kecamatan: '',
  apn_kalurahan: '',
  apn_nomor_hp_utama: '',
  apn_nomor_hp: '',
  apn_dite_sej: '',
  apn_st_dom: '',
  apn_status_sipil: '',
  apn_jm_tangg: '',
  jenis: '',
  application_id: '',
  formData1: '',
  isKTPUploaded: false,
  isCamera: false,
  isSelfieUploaded: false,
  openSelfieDialog: false,
  selfieDataUri: '',
  selfieTempDataUri: '',
  files: [],
  ktpThumb: '',
  selfieThumb: '',
  saya_tel: false,
  isAccept: false,
  data_apn_st_dom: [],
  data_apn_status_sipil: [],
  data_apn_jm_tangg: [],
  data_hubungan: [],
  data_tipe_peker: [],
  data_pendid: [],
  data_nama_bank: [],
  data_tujuan: [],
  ktp_self_file: '',
  openLoanDialog: false,
  disbursed: '',
  fee: '',
  amount: '',
  repayment_amount: '',
  helperText: '',
  grab_phone: '',
  isValidPhone: false,
  isTimeout: false,
  otpTimer: 120,
  otpTimerFixed: 120,
  delayTime: 1000,
  isFilledOTP: false,
  isWrong: false,
  nik: '',
  email_nik: '',
  forgot_email: '',
  offerData: [],
  isLoader: false,
  sliderVal: 0,
  showOffer: false,
  bottom: false,
  isNotificationOpened: false,
  isLoadingOverlayShown: false,
  loginPinError: null,
  forgotPinError: null,
  phoneNumberEmailForgotPIN: null,
  isForgotPasswordSuccessDialogOpen: false,
  forgotPasswordButtonDisabled: true,
  isFirstPinFilled: false,
  createPinError: null,
  phoneNumber: null,
  preAuthToken: null,
  linkAccountButtonDisabled: true,
  loginButtonDisabled: true,
  otpButtonDisabled: true,
  otpTimerRestart: false,
  otpError: null,
  offers: null,
  isErrorPageShown: false,
  isEmptyOfferPageShown: false,
  offer: null,
  programId: null,
  repaymentPlans: null,
  loanAmountMin: 0,
  loanAmountMax: 0,
  loanAmount: 0,
  isEmptyRepaymentPageShown: false,
  repaymentPlanSelectedNumber: null,
  repaymentPlan: {
    tenure: 0,
    interest_rate_type: '',
    interest_rate: 0,
    daily_repayment: 0,
    upfront_fee_type: '',
    upfront_fee: 0,
    repayment_amount: 0,
  },
  frequencyType: null,
  loanDisbursementAmount: 0,
  penaltyType: '',
  penaltyValue: 0,
  usernameInvalid: false,
  isOTPSent: false,
  isGetLoanActive: false,
  totalPayment: 0,
  preOpen: false,
  isEmptyLoanPageShown: false,
  accountEmail: '',
  accountPhone: '',
  accountNik: '',
  isNewEnterPin: false,
  isReEnterPin: false,
  openLocationAccessDialog: true,
  grabLinkAccountError: null,
  openLocationAccessGrabPolicyDialog: false,
  loginError: null,
  jobTypes: [
    'pengusaha',
    'staf rumah tangga',
    'freelance',
    'pegawai swasta',
    'pegawai negeri',
  ],
  paddingBot: 0,
  imageTypes: null,
  cameraAllowError:
    'Untuk melanjutkan proses pengajukan, mohon izinkan penggunaan kamera pada perangkat Anda.',
  loanCreationError:
    'Maaf, bank yang kamu masukkan tidak terdaftar. Kirimkan email dan informasikan masalah ini ke cs@julo.co.id.',
  generalErrorMsg: 'Sedang terjadi masalah',
  notificationDelayTime: 6000,
  noLoanXidError: 'Maaf, sedang terjadi masalah mohon dicoba kembali',
  doubleLoanError:
    'Anda sudah mengajukan pinjaman, Silahkah refresh halaman web Anda',
};

const actions = {
  setState: (store, name, value) => {
    store.setState({ [name]: value });
  },
  setStates: (store, object) => {
    store.setState(object);
  },
  openTnCDialog: (store, name, value) => {
    store.setState({ [name]: value });
  },
  openPersonalIdentityDialog: (store, name, value) => {
    store.setState({ [name]: value });
  },
  openLoanDetailsDialog: (store, name, value) => {
    store.setState({ [name]: value });
  },
  openPinChangeSuccessDialogDialog: (store, name, value) => {
    store.setState({ [name]: value });
  },
  openPrivyFailOverDialog: (store, name, value) => {
    store.setState({ [name]: value });
  },
  openPrivyFailOverAcceptedDialog: (store, name, value) => {
    store.setState({ [name]: value });
  },
  openBankValidationDialog: (store, name, value) => {
    store.setState({ [name]: value });
  },
  openNotification: (store, message, severity = 'success') => {
    store.setState({
      isNotificationOpened: true,
      notificationMessage: message,
      notificationSeverity: severity,
    });
  },

  closeNotification: (store) => {
    store.setState({
      isNotificationOpened: false,
      notificationMessage: '',
      notificationSeverity: 'success',
    });
  },

  openLoadingOverlay: (store, message = '') => {
    store.setState({
      isLoadingOverlayShown: true,
      loadingOverlayMessage: message,
    });
  },

  closeLoadingOverlay: (store) => {
    store.setState({
      isLoadingOverlayShown: false,
      loadingOverlayMessage: '',
    });
  },

  thousands_separators: (store, num) => {
    if (num === null) {
      return '0';
    } else {
      const num_parts = num.toString().split('.');
      num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return num_parts.join('.');
    }
  },
  getScreenHeight: () => {
    let ht;
    ht = Math.abs(screen.height) + 'px';
    return ht;
  },
  getScreenHeightVh: () => {
    let ht;
    if (screen.height >= 500) {
      ht = '100vh';
    } else {
      ht = '180vh';
    }
    return ht;
  },
  clearApplicationLocationStorage: () => {
    localStorage.setItem('depend', '');
    localStorage.setItem('homeStatus', '');
    localStorage.setItem('maritalStatus', '');
    localStorage.setItem('email', '');
    localStorage.setItem('email_', '');
    localStorage.setItem('fullname', '');
    localStorage.setItem('fullname_', '');
    localStorage.setItem('birthPlace', '');
    localStorage.setItem('birthPlace_', '');

    localStorage.setItem('address', '');
    localStorage.setItem('address_', '');
    localStorage.setItem('addressProvinsi', '');
    localStorage.setItem('addressProvinsi_', '');
    localStorage.setItem('addressKabupaten', '');
    localStorage.setItem('addressKabupaten_', '');
    localStorage.setItem('addressKecamatan', '');
    localStorage.setItem('addressKecamatan_', '');
    localStorage.setItem('addressKelurahan', '');
    localStorage.setItem('addressKelurahan_', '');
    localStorage.setItem('addressKodepos', '');
    localStorage.setItem('addressKodepos_', '');

    localStorage.setItem('mobilePhone2', '');
    localStorage.setItem('mobilePhone2_', '');
    localStorage.setItem('dob', '');
    localStorage.setItem('dob_', '');
    localStorage.setItem('occupiedSince', '');
    localStorage.setItem('occupiedSince_', '');
    localStorage.setItem('gender', '');

    localStorage.setItem('closeKinName', '');
    localStorage.setItem('closeKinName_', '');
    localStorage.setItem('closeKinMobilePhone', '');
    localStorage.setItem('closeKinMobilePhone_', '');
    localStorage.setItem('kinRelationship', '');
    localStorage.setItem('kinName', '');
    localStorage.setItem('kinName_', '');
    localStorage.setItem('kinMobilePhone', '');
    localStorage.setItem('kinMobilePhone_', '');
    localStorage.setItem('lastEducation', '');
    localStorage.setItem('companyName', '');
    localStorage.setItem('companyName_', '');
    localStorage.setItem('profession', '');
    localStorage.setItem('profession_', '');
    localStorage.setItem('jobIndustry', '');
    localStorage.setItem('jobIndustry_', '');
    localStorage.setItem('jobType', '');
    localStorage.setItem('jobStart', '');
    localStorage.setItem('jobStart_', '');

    localStorage.setItem('monthlyIncome', '');
    localStorage.setItem('monthlyIncome_', '');
    localStorage.setItem('monthlyHousingCost', '');
    localStorage.setItem('monthlyHousingCost_', '');
    localStorage.setItem('monthlyExpenses', '');
    localStorage.setItem('monthlyExpenses_', '');
    localStorage.setItem('totalCurrentDebt', '');
    localStorage.setItem('totalCurrentDebt_', '');
    localStorage.setItem('bankName', '');
    localStorage.setItem('bankAccountNumber', '');
    localStorage.setItem('bankAccountNumber_', '');
    localStorage.setItem('loanPurpose', '');
    localStorage.setItem('loanPurposeDesc', '');
    localStorage.setItem('loanPurposeDesc_', '');
    localStorage.setItem('ktpPhoto', '');
    localStorage.setItem('ktpFile', '');
    localStorage.setItem('selfiePhoto', '');
    localStorage.setItem('ktpSelfieFile', '');
    localStorage.setItem('financialInfo', '');
    localStorage.setItem('jobInfo', '');
    localStorage.setItem('familyInfo', '');
    localStorage.setItem('personalInfo', '');
    localStorage.setItem('home_status', '');
    localStorage.setItem('marital_status', '');
    localStorage.setItem('kin_relationship', '');
    localStorage.setItem('job_type', '');
    localStorage.setItem('last_education', '');
    localStorage.setItem('bank_name', '');
    localStorage.setItem('loan_purpose', '');
  },
  convertDataURLtoFile: (store, dataurl, filename) => {
    if (dataurl) {
      const sp = dataurl.split(',');
      if (sp.length === 2) {
        if (sp[1] === '') {
          return '';
        } else {
          const arr = dataurl.split(',');
          const mime = arr[0].match(/:(.*?);/)[1];
          const bstr = atob(arr[1]);
          let n = bstr.length;
          let u8arr = new Uint8Array(n);

          while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
          }

          return new File([u8arr], filename, { type: mime });
        }
      } else {
        return '';
      }
    }
  },
  filterAddress: (store, type, value, data = []) => {
    let nwSubDistricts = data;
    if (nwSubDistricts) {
      let regencies = [],
        villages = [],
        subDistrict = [],
        postalCode = [];
      nwSubDistricts = JSON.parse(nwSubDistricts);
      const allSubDistricts = nwSubDistricts.map((x) => {
        const arr = x.split(',');
        return {
          postalCode: arr[0],
          subDistrict: arr[1],
          village: arr[2],
          regency: arr[3],
          province: arr[4],
        };
      });
      if (type === 'Kabupaten') {
        regencies = [
          ...new Set(
            allSubDistricts
              .filter((x) => x.province === value)
              .map((x) => x.regency),
          ),
        ];
        store.setState({ regencies: regencies });
      }
      if (type === 'Kecamatan') {
        villages = [
          ...new Set(
            allSubDistricts
              .filter((x) => x.regency === value)
              .map((x) => x.village),
          ),
        ];
        store.setState({ villages: villages });
      }
      if (type === 'Kelurahan') {
        subDistrict = [
          ...new Set(
            allSubDistricts
              .filter((x) => x.village === value)
              .map((x) => x.subDistrict),
          ),
        ];
        store.setState({ subDistrict: subDistrict });
      }
      if (type === 'Kodepos') {
        postalCode = [
          ...new Set(
            allSubDistricts
              .filter((x) => x.subDistrict === value)
              .map((x) => x.postalCode),
          ),
        ];
        if (postalCode.length > 0) {
          store.setState({ postalCode: postalCode[0] });
          encryptedLocalStorage.setItem('addressKodepos', postalCode[0]);
          encryptedLocalStorage.setItem('addressKodepos_', postalCode[0]);
        } else {
          store.setState({ postalCode: '' });
          encryptedLocalStorage.setItem('addressKodepos', '');
          encryptedLocalStorage.setItem('addressKodepos_', '');
        }
      }
    }
  },
  filterJobs: (store, type, value) => {
    let jobs = localStorage.getItem('job');
    if (jobs) {
      jobs = JSON.parse(jobs);
      if (
        initialState.jobTypes.includes(
          localStorage.getItem('jobType').toLowerCase(),
        )
      ) {
        let bpk = [],
          pk = [];
        let allJobs = jobs.map((x) => {
          const arr = x.split(',');
          const checkBpk = bpk.indexOf(arr[0]);
          if (checkBpk === -1) {
            bpk.push(arr[0]);
          }
          return {
            bpk: arr[0],
            pk: arr[1],
          };
        });
        store.setState({ bpk: bpk });
        if (type === 'profession') {
          pk = [
            ...new Set(allJobs.filter((x) => x.bpk === value).map((x) => x.pk)),
          ];
          store.setState({ pk: pk });
        }

        store.setState({ showBidangPk: true });
        store.setState({ showPk: true });
        store.setState({ showCmp: true });
      } else {
        store.setState({ showBidangPk: false });
        store.setState({ showPk: false });
        store.setState({ showCmp: false });
      }
    } else {
      store.setState({ showBidangPk: false });
      store.setState({ showPk: false });
      store.setState({ showCmp: false });
    }
  },
  getUploadCaption: (store, caption) => {
    let newCaption = '';
    if (caption === 'selfie_dengan_ktp_privy') {
      newCaption = 'Foto Selfie dengan KTP';
    } else if (caption === 'selfie_privy') {
      newCaption = 'Foto Selfie';
    } else if (caption === 'sim_privy') {
      newCaption = 'Foto SIM';
    } else if (caption === 'kk_privy') {
      newCaption = 'Foto KK';
    } else if (caption === 'ektp_privy') {
      newCaption = 'Foto e-KTP';
    } else if (caption === 'passport_privy') {
      newCaption = 'Foto Passport';
    } else if (caption === 'passport_selfie_privy') {
      newCaption = 'Foto Selfie dengan Passport';
    } else {
      newCaption = 'Foto KTP';
    }
    return newCaption;
  },
  getResponseError: (store, error = '') => {
    if (error) {
      if (
        error.response &&
        error.response?.data &&
        error.response?.data?.errors &&
        error.response?.data?.errors.length > 0
      ) {
        return error.response.data.errors[0];
      } else if (
        error.response &&
        error.response?.data &&
        error.response?.data?.status &&
        error.response?.data?.error_message
      ) {
        return error.message;
      } else {
        return 'Sedang Terjadi Masalah pada Jaringan';
      }
    } else {
      return initialState.generalErrorMsg;
    }
  },
};

const useGlobalState = globalHook(React, initialState, actions);

export default useGlobalState;
